@if (viewAnimation==true) {<ng-lottie height="70%" [options]="options" (loopComplete)="onLoopComplete()"></ng-lottie>}